import { useState } from 'react';
import CancelPopUp from '../CancelPopUp/CancelPopUp';
import FormSuccess from '../Forms/FormSuccess';
import {
  ButtonWrapper,
  CancelButton,
  DialogHeader,
  DialogHeading,
  LeftGrid,
  SaveButton,
} from '../../Episode/Episode.Styled';
import moment from 'moment';
import { ContentTitle, RightGrid } from '../../ui/styled';
import BackIcon from '../Back/BackIcon';
import PageHeading from '../Heading/PageHeading';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import { backDrop, dateFormat } from '../../../constants';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import Typography from '@mui/material/Typography';

export const getSaveCancel = (handleCancel, handleDelete, handleSubmit, isSubmitting) => {
  return (
    <ButtonWrapper>
      <CancelButton variant="contained" onClick={handleCancel}>
        Cancel
      </CancelButton>
      {handleDelete && (
        <CancelButton variant="contained" onClick={handleDelete}>
          Delete
        </CancelButton>
      )}
      <SaveButton variant="contained" disabled={isSubmitting} onClick={handleSubmit}>
        Save
      </SaveButton>
    </ButtonWrapper>
  );
};

export const getFormSuccess = (formSuccess, setFormSuccess, isNewForm) => {
  return (
    <FormSuccess
      formSuccess={formSuccess}
      setFormSuccess={setFormSuccess}
      isNewForm={isNewForm}
    />
  );
};

export const getCancelPopup = (cancelPopUp, setCancelPopUp) => {
  return (
    <CancelPopUp cancelPopUp={cancelPopUp} setCancelPopUp={setCancelPopUp} />
  );
};

export const getHeading = (title) => {
  return (
    <ContentTitle container>
      <RightGrid item xs={12} sm={6}>
        <BackIcon />
        <PageHeading title={title} />
      </RightGrid>
      <LeftGrid item xs={12} sm={6}></LeftGrid>
    </ContentTitle>
  );
};

export const getBackdrop = (openBackdrop) => {
  return (
    <Backdrop sx={backDrop} open={openBackdrop}>
      <CircularProgress />
    </Backdrop>
  );
};

export const getDialogHeading = (title, id, handleClose) => {
  return (
    <>
      <DialogHeader>
        <DialogHeading variant="h5">
          {title} : {id}
        </DialogHeading>
        <IconButton onClick={handleClose}>
          <CloseIcon />
        </IconButton>
      </DialogHeader>
    </>
  );
};

export const renderDateCell = (params) => {
  const dateValue = params.value
    ? moment(params.value).format(dateFormat).split('T')[0]
    : '';

  return <Typography>{dateValue}</Typography>;
};

export const renderExpandCell = (params) => {
  return <Typography>{params.value}</Typography>;
};

export const getRandomId = () => {
  return Math.random().toString(16).substring(2);
};

export const formatDateMDY = (dateString) => {
  const date = new Date(dateString);
  const month = date.getMonth() + 1;
  const day = date.getDate();
  const year = date.getFullYear();
  const formattedMonth = month < 10 ? `0${month}` : month;
  const formattedDay = day < 10 ? `0${day}` : day;

  return `${formattedMonth}/${formattedDay}/${year}`;
};

export const format180DateMDY = (dateString) => {
  var date = new Date(dateString);
  date.setDate(date.getDate() + 180)
  const month = date.getMonth() + 1;
  const day = date.getDate();
  const year = date.getFullYear();
  const formattedMonth = month < 10 ? `0${month}` : month;
  const formattedDay = day < 10 ? `0${day}` : day;

  return `${formattedMonth}/${formattedDay}/${year}`;
};

export const rowEvenOdd = (index) => (index % 2 === 0 ? 'even' : 'odd');

export const getYesNo = (condition) => [
  { label: 'Yes', checked: condition ? 'checked' : '' },
  { label: 'No', checked: condition ? '' : 'checked' },
];

export const getValidDate = (date) => {
  return date ? moment(date).format('MM/DD/YYYY') : '';
};

export const getValidTime = (time) => {
  return time ? moment(time).format('HH:mm') : '';
};

export const getAscendingSort = (field) => ({
  sorting: {
    sortModel: [{ field, sort: 'asc' }],
  },
});

export const convertYesNo = (value) => (value ? 'Yes' : 'No');

export const useLoading = () => {
  const [loading, setLoading] = useState(true);

  const showLoading = () => setLoading(true);
  const hideLoading = () => setLoading(false);

  return {
    loading,
    showLoading,
    hideLoading,
  };
};
